import { configureStore } from "@reduxjs/toolkit";
import { transactionReducer } from "../Features/Transaction/TrnasactionSlice";
import { transactionEditReducer } from "../Features/TransactionEdit/TransactionEditSlice";
import { filterReducer } from "../Features/filter/filterSlice";

export const store = configureStore({
  reducer: {
    transaction: transactionReducer,
    transactionEdit: transactionEditReducer,
    filter: filterReducer,
  },
});
